var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"winner",style:({ 'background-color': _vm.color})},[_c('p',[_vm._v("優勝 "+_vm._s(_vm.winner))])])}
var staticRenderFns = []

export { render, staticRenderFns }